module.exports = __webpack_public_path__ + "static/media/Piercing-ear-correction.5dd020f9.png";